"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Footer_component_exports = {};
__export(Footer_component_exports, {
  Footer: () => Footer
});
module.exports = __toCommonJS(Footer_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
const Footer = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({}, props), {
      "data-testid": "footerContainer",
      className: "mt-10 box-border flex w-full flex-col justify-end font-primary md:flex-row",
      children: import_react.Children.map(children, (child) => {
        if ((0, import_react.isValidElement)(child)) {
          return (0, import_react.cloneElement)(child, __spreadValues({}, props));
        }
        return child;
      })
    })
  );
};
const FooterLeftContainer = ({ children }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "items-left box-border flex w-full gap-2.5 md:p-0", children });
const FooterRightContainer = ({ children }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "mt-2 box-border flex w-full flex-col gap-2.5 md:mt-0 md:flex-row md:items-center md:justify-end", children });
Footer.LeftContainer = FooterLeftContainer;
Footer.RightContainer = FooterRightContainer;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Footer
});
//# sourceMappingURL=Footer.component.js.map